<template>
  <div id="park-pickup">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- notice -->
      <section>
        <div class="l-main l-main--bg-border--green l-main--bg-border pt-60">
          <div class="l-main__head">
            <a href="#" @click.prevent="backToMobileorderTop" class="l-main__head--control l-main__head--control--back mobileorder">
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="">
              受け取り方法を<br />変更する
            </a>
            <div v-if="orders && orders.length && $store.state.unread && $store.state.unread[SHOP_ID]" class="l-header__cart--number history">{{$store.state.unread[SHOP_ID]}}</div>
            <div v-show="orders && orders.length" class="c-btn l-park-pickup__title-box--btn" @click.prevent="$router.push('/mobileorder/history')">注文状況・履歴</div>
          </div>
          <div class="l-park-pickup">
            <div class="l-park-pickup__title-box">
              <div class="l-park-pickup__title-box--title top mb-8" v-if="type == 'pickup'">
                {{title}}
              </div>
              <div class="l-park-pickup__title-box--title top mb-8" v-else>
                <small>＜モバイルオーダー＞</small><br />
                {{title}}
              </div>
            </div>

            <div class="swiper-container c-tab-menu js-swiper_tab c-tab-nav mb-10">
              <div class="swiper-wrapper c-tab-menu__wrap">
                <div class="swiper-slide c-tab-nav__item is-active">飲食（{{mobileOrderProvidersFoodCount}}）</div>
                <div class="swiper-slide c-tab-nav__item">飲食以外（{{mobileOrderProvidersNonFoodCount}}）</div>
              </div>
            </div>
            <div class="swiper-container js-swiper_tab_body">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <ul class="c-list-store-pickup">
                    <li v-if="mobileOrderProvidersFood.length == 0">
                      <div class="notAvailable">ただいまご利用いただける店舗がありません</div>
                    </li>
                    <li v-for="(tenant, index) in mobileOrderProvidersFoodAvailable" :key="`pickup_available_${index}`">
                      <a href="javascript:void(0)" class="c-list-store-pickup__item">
                        <div class="c-list-store-pickup__left">
                          <div class="c-list-store-pickup__img" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                            <img :src="getImgSrc(tenant.data().image[0])" alt="">
                          </div>
                          <button v-if="follows.includes(tenant.id)" class="c-btn-follow c-btn-follow--sm is-active mb-8" v-on:click="deleteFollows(tenant.id)">
                            <span class="c-btn-follow__active">フォロー中</span>
                          </button>
                          <button v-else class="c-btn-follow c-btn-follow--sm mb-8" v-on:click="addFollows(tenant.id)">
                            <span class="">フォローする</span>
                          </button>
                          <button class="c-btn-check c-btn-check--sm mb-8" v-on:click="$router.push('/store/floorguide')" v-if="type == 'pickup' && showFloorGuide">
                            <img src="/assets/images/icon/icon-map-grey.svg" alt="" />フロアガイド<br />で確認
                          </button>
                          <template v-if="type == 'pickup'">
                            <span class="handling-format-label togo" v-if="tenant.data().handlingFormatToGo && tenant.data().handlingFormatToGo.enabled">お持ち帰り</span>
                            <span class="handling-format-label forhere" v-if="tenant.data().handlingFormatForHere && tenant.data().handlingFormatForHere.enabled">店内でお食事</span>
                          </template>
                          <template v-else-if="type == 'drivethru'">
                            <span class="handling-format-label drivethru" v-if="tenant.data().handlingFormatDeliveryLane && tenant.data().handlingFormatDeliveryLane.enabled">ドライブスルー</span>
                          </template>
                          <template v-else-if="type == 'parkandpickup'">
                            <span class="handling-format-label parkandpickup" v-if="tenant.data().handlingFormatDeliveryParking && tenant.data().handlingFormatDeliveryParking.enabled">駐車場受け取り</span>
                          </template>
                          <template v-else-if="type == 'reservation'">
                            <span class="handling-format-label reservation" v-if="tenant.data().handlingFormatReservation && tenant.data().handlingFormatReservation.enabled">ご来店予約</span>
                          </template>
                        </div>
                        <div class="c-list-store-pickup__right" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                          <div class="c-list-store-pickup__area">{{tenant.data().location}}</div>
                          <div class="c-list-store-pickup__name">{{tenant.data().shopName}}</div>
                          <div class="c-estimated-group c-estimated-group--vertical-center" v-if="isEnableTimebase(tenant)">
                            <div class="c-estimated">
                              <img src="/assets/images/icon/icon-clock.svg" alt="" />受け取り目安
                            </div>
                            <div class="c-estimated-time">{{ estimateTime(tenant, type == 'pickup' ? 'pickup' : 'delivery') }}</div>
                          </div>
                          <hr />
                          <p class="mb-8">
                            {{type == 'pickup' ? 'モバイルオーダー' : 'ドライブスルー'}} <br />
                            予約受付時間
                          </p>
                          <div class="mb-8">
                            <p>
                              <b v-html="calcAcceptTime(tenant.data(), type)">
                              </b>
                            </p>
                          </div>
                          <p>
                            <template v-if="tenant.data().floorGuideNo">
                            フロアガイド番号： {{tenant.data().floorGuideNo}} <br />
                            </template>
                            <template v-if="tenant.data().businessHour">
                            営業時間：{{ tenant.data().businessHour.from }}〜{{ tenant.data().businessHour.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourBusinessDay">
                            営業時間（平日）：{{ tenant.data().businessHourBusinessDay.from }}〜{{ tenant.data().businessHourBusinessDay.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourHoliday">
                            営業時間（土日祝）：{{ tenant.data().businessHourHoliday.from }}〜{{ tenant.data().businessHourHoliday.to }}<br />
                            </template>
                            連絡先：{{tenant.data().tel}}
                          </p>
                        </div>
                        <div class="price-notice" v-if="isPriceNoticeRequired(tenant)">
                          ※商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わる場合があります
                        </div>
                      </a>
                    </li>
                    <div class="c-notice-pickup" v-if="mobileOrderProvidersFoodUnavailable && mobileOrderProvidersFoodUnavailable.length > 0">
                      以下ショップについて、ただいまの時間は受付を行なっておりません。
                    </div>
                    <li v-for="(tenant, index) in mobileOrderProvidersFoodUnavailable" :key="`pickup_unavailable_${index}`">
                      <a href="javascript:void(0)" class="c-list-store-pickup__item">
                        <div class="c-list-store-pickup__left">
                          <div class="c-list-store-pickup__img" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                            <img :src="getImgSrc(tenant.data().image[0])" alt="">
                          </div>
                          <button v-if="follows.includes(tenant.id)" class="c-btn-follow c-btn-follow--sm is-active mb-8" v-on:click="deleteFollows(tenant.id)">
                            <span class="c-btn-follow__active">フォロー中</span>
                          </button>
                          <button v-else class="c-btn-follow c-btn-follow--sm mb-8" v-on:click="addFollows(tenant.id)">
                            <span class="">フォローする</span>
                          </button>
                          <button class="c-btn-check c-btn-check--sm mb-8" v-on:click="$router.push('/store/floorguide')" v-if="type == 'pickup' && showFloorGuide">
                            <img src="/assets/images/icon/icon-map-grey.svg" alt="" />フロアガイド<br />で確認
                          </button>
                          <template v-if="type == 'pickup'">
                            <span class="handling-format-label togo" v-if="tenant.data().handlingFormatToGo && tenant.data().handlingFormatToGo.enabled">お持ち帰り</span>
                            <span class="handling-format-label forhere" v-if="tenant.data().handlingFormatForHere && tenant.data().handlingFormatForHere.enabled">店内でお食事</span>
                          </template>
                          <template v-else-if="type == 'drivethru'">
                            <span class="handling-format-label drivethru" v-if="tenant.data().handlingFormatDeliveryLane && tenant.data().handlingFormatDeliveryLane.enabled">ドライブスルー</span>
                          </template>
                          <template v-else-if="type == 'parkandpickup'">
                            <span class="handling-format-label parkandpickup" v-if="tenant.data().handlingFormatDeliveryParking && tenant.data().handlingFormatDeliveryParking.enabled">駐車場受け取り</span>
                          </template>
                        </div>
                        <div class="c-list-store-pickup__right" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                          <div class="c-list-store-pickup__area">{{tenant.data().location}}</div>
                          <div class="c-list-store-pickup__name">{{tenant.data().shopName}}</div>
                          <div class="c-estimated-group c-estimated-group--vertical-center">
                            <div class="c-estimated-time">ただいまの時間は受け付けておりません。</div>
                          </div>
                          <hr />
                          <p class="mb-8">
                            {{type == 'pickup' ? 'モバイルオーダー' : 'ドライブスルー'}}<br />
                            予約受付時間
                          </p>
                          <div class="mb-8">
                            <p>
                              <b v-html="calcAcceptTime(tenant.data(), type)">
                              </b>
                            </p>
                          </div>
                          <p>
                            <template v-if="tenant.data().floorGuideNo">
                            フロアガイド番号： {{tenant.data().floorGuideNo}} <br />
                            </template>
                            <template v-if="tenant.data().businessHour">
                            営業時間：{{ tenant.data().businessHour.from }}〜{{ tenant.data().businessHour.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourBusinessDay">
                            営業時間（平日）：{{ tenant.data().businessHourBusinessDay.from }}〜{{ tenant.data().businessHourBusinessDay.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourHoliday">
                            営業時間（土日祝）：{{ tenant.data().businessHourHoliday.from }}〜{{ tenant.data().businessHourHoliday.to }}<br />
                            </template>
                            連絡先：{{tenant.data().tel}}
                          </p>
                        </div>
                        <div class="price-notice" v-if="isPriceNoticeRequired(tenant)">
                          ※商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わる場合があります
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="swiper-slide">
                  <ul class="c-list-store-pickup">
                    <li v-if="mobileOrderProvidersNonFood.length == 0">
                      <div class="notAvailable">ただいまご利用いただける店舗がありません</div>
                    </li>
                    <li v-for="(tenant, index) in mobileOrderProvidersNonFoodAvailable" :key="`pickup_available_${index}`">
                      <a href="javascript:void(0)" class="c-list-store-pickup__item">
                        <div class="c-list-store-pickup__left">
                          <div class="c-list-store-pickup__img" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                            <img :src="getImgSrc(tenant.data().image[0])" alt="">
                          </div>
                          <button v-if="follows.includes(tenant.id)" class="c-btn-follow c-btn-follow--sm is-active mb-8" v-on:click="deleteFollows(tenant.id)">
                            <span class="c-btn-follow__active">フォロー中</span>
                          </button>
                          <button v-else class="c-btn-follow c-btn-follow--sm mb-8" v-on:click="addFollows(tenant.id)">
                            <span class="">フォローする</span>
                          </button>
                          <button class="c-btn-check c-btn-check--sm mb-8" v-on:click="$router.push('/store/floorguide')" v-if="type == 'pickup' && showFloorGuide">
                            <img src="/assets/images/icon/icon-map-grey.svg" alt="" />フロアガイド<br />で確認
                          </button>
                          <template v-if="type == 'pickup'">
                            <span class="handling-format-label togo" v-if="tenant.data().handlingFormatToGo && tenant.data().handlingFormatToGo.enabled">お持ち帰り</span>
                            <span class="handling-format-label forhere" v-if="tenant.data().handlingFormatForHere && tenant.data().handlingFormatForHere.enabled">店内でお食事</span>
                          </template>
                          <template v-else-if="type == 'drivethru'">
                            <span class="handling-format-label drivethru" v-if="tenant.data().handlingFormatDeliveryLane && tenant.data().handlingFormatDeliveryLane.enabled">ドライブスルー</span>
                          </template>
                          <template v-else-if="type == 'parkandpickup'">
                            <span class="handling-format-label parkandpickup" v-if="tenant.data().handlingFormatDeliveryParking && tenant.data().handlingFormatDeliveryParking.enabled">駐車場受け取り</span>
                          </template>
                        </div>
                        <div class="c-list-store-pickup__right" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                          <div class="c-list-store-pickup__area">{{tenant.data().location}}</div>
                          <div class="c-list-store-pickup__name">{{tenant.data().shopName}}</div>
                          <div class="c-estimated-group c-estimated-group--vertical-center" v-if="isEnableTimebase(tenant)">
                            <div class="c-estimated">
                              <img src="/assets/images/icon/icon-clock.svg" alt="" />受け取り目安
                            </div>
                            <div class="c-estimated-time">{{ estimateTime(tenant, type == 'pickup' ? 'pickup' : 'delivery') }}</div>
                          </div>
                          <hr />
                          <p class="mb-8">
                            {{type == 'pickup' ? 'モバイルオーダー' : 'ドライブスルー'}} <br />
                            予約受付時間
                          </p>
                          <div class="mb-8">
                            <p>
                              <b v-html="calcAcceptTime(tenant.data(), type)">
                              </b>
                            </p>
                          </div>
                          <p>
                            <template v-if="tenant.data().floorGuideNo">
                            フロアガイド番号： {{tenant.data().floorGuideNo}} <br />
                            </template>
                            <template v-if="tenant.data().businessHour">
                            営業時間：{{ tenant.data().businessHour.from }}〜{{ tenant.data().businessHour.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourBusinessDay">
                            営業時間（平日）：{{ tenant.data().businessHourBusinessDay.from }}〜{{ tenant.data().businessHourBusinessDay.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourHoliday">
                            営業時間（土日祝）：{{ tenant.data().businessHourHoliday.from }}〜{{ tenant.data().businessHourHoliday.to }}<br />
                            </template>
                            連絡先：{{tenant.data().tel}}
                          </p>
                        </div>
                      </a>
                    </li>
                    <div class="c-notice-pickup" v-if="mobileOrderProvidersNonFoodUnavailable && mobileOrderProvidersNonFoodUnavailable.length > 0">
                      以下ショップについて、ただいまの時間は受付を行なっておりません。
                    </div>
                    <li v-for="(tenant, index) in mobileOrderProvidersNonFoodUnavailable" :key="`pickup_unavailable_${index}`">
                      <a href="javascript:void(0)" class="c-list-store-pickup__item">
                        <div class="c-list-store-pickup__left">
                          <div class="c-list-store-pickup__img" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                            <img :src="getImgSrc(tenant.data().image[0])" alt="">
                          </div>
                          <button v-if="follows.includes(tenant.id)" class="c-btn-follow c-btn-follow--sm is-active mb-8" v-on:click="deleteFollows(tenant.id)">
                            <span class="c-btn-follow__active">フォロー中</span>
                          </button>
                          <button v-else class="c-btn-follow c-btn-follow--sm mb-8" v-on:click="addFollows(tenant.id)">
                            <span class="">フォローする</span>
                          </button>
                          <button class="c-btn-check c-btn-check--sm mb-8" v-on:click="$router.push('/store/floorguide')" v-if="type == 'pickup' && showFloorGuide">
                            <img src="/assets/images/icon/icon-map-grey.svg" alt="" />フロアガイド<br />で確認
                          </button>
                          <template v-if="type == 'pickup'">
                            <span class="handling-format-label togo" v-if="tenant.data().handlingFormatToGo && tenant.data().handlingFormatToGo.enabled">お持ち帰り</span>
                            <span class="handling-format-label forhere" v-if="tenant.data().handlingFormatForHere && tenant.data().handlingFormatForHere.enabled">店内でお食事</span>
                          </template>
                          <template v-else-if="type == 'drivethru'">
                            <span class="handling-format-label drivethru" v-if="tenant.data().handlingFormatDeliveryLane && tenant.data().handlingFormatDeliveryLane.enabled">ドライブスルー</span>
                          </template>
                          <template v-else-if="type == 'parkandpickup'">
                            <span class="handling-format-label parkandpickup" v-if="tenant.data().handlingFormatDeliveryParking && tenant.data().handlingFormatDeliveryParking.enabled">駐車場受け取り</span>
                          </template>
                        </div>
                        <div class="c-list-store-pickup__right" @click.prevent="$router.push(`/mobileorder/shop/${tenant.id}/${type}`)">
                          <div class="c-list-store-pickup__area">{{tenant.data().location}}</div>
                          <div class="c-list-store-pickup__name">{{tenant.data().shopName}}</div>
                          <div class="c-estimated-group c-estimated-group--vertical-center">
                            <div class="c-estimated-time">ただいまの時間は受け付けておりません。</div>
                          </div>
                          <hr />
                          <p class="mb-8">
                            {{type == 'pickup' ? 'モバイルオーダー' : 'ドライブスルー'}}<br />
                            予約受付時間
                          </p>
                          <div class="mb-8">
                            <p>
                              <b v-html="calcAcceptTime(tenant.data(), type)">
                              </b>
                            </p>
                          </div>
                          <p>
                            <template v-if="tenant.data().floorGuideNo">
                            フロアガイド番号： {{tenant.data().floorGuideNo}} <br />
                            </template>
                            <template v-if="tenant.data().businessHour">
                            営業時間：{{ tenant.data().businessHour.from }}〜{{ tenant.data().businessHour.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourBusinessDay">
                            営業時間（平日）：{{ tenant.data().businessHourBusinessDay.from }}〜{{ tenant.data().businessHourBusinessDay.to }}<br />
                            </template>
                            <template v-if="tenant.data().businessHourHoliday">
                            営業時間（土日祝）：{{ tenant.data().businessHourHoliday.from }}〜{{ tenant.data().businessHourHoliday.to }}<br />
                            </template>
                            連絡先：{{tenant.data().tel}}
                          </p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
    </main>
    <footer-cart></footer-cart>
    <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getMobileOrderTenants, getDriveOrderTenants, getParkAndPickupOrderTenants, getMyOrders, getMobileOrderConfig, isShowFloorGuide } from "../store/firestore";
import Swiper from "swiper";
const $ = window.$;
import Alert from "../components/Alert.vue";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "MobileOrderStoreList",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    Alert,
    PopAlert
  },
  data() {
    return {
      mobileOrderProviders: [],
      mobileOrderProvidersNonFood: [],
      mobileOrderProvidersFood: [],
      mobileOrderProvidersAvailable: [],
      mobileOrderProvidersNonFoodAvailable: [],
      mobileOrderProvidersFoodAvailable: [],
      mobileOrderProvidersUnavailable: [],
      mobileOrderProvidersNonFoodUnavailable: [],
      mobileOrderProvidersFoodUnavailable: [],
      mobileOrderProvidersCount: undefined,
      mobileOrderProvidersFoodCount: undefined,
      mobileOrderProvidersNonFoodCount: undefined,
      orders: [],
      type: this.$route.params.type,
      mobileOrderConfig: null,
      loading: false,
      showFloorGuide: false
    }
  },
  async created() {
    const shopId = this.$store.state.shopId;
    this.showFloorGuide = await isShowFloorGuide(shopId);
  },
  mixins: [Tenant],
  async mounted() {
    Common.initDom();

    function setCurrentSlide(ele, index) {
      $(".js-swiper_tab .swiper-slide").removeClass("is-active");
      ele.addClass("is-active");
      //swiper_tab.initialSlide=index;
    }

    var swiper_tab = new Swiper('.js-swiper_tab', {
      slidesPerView: 2,
      paginationClickable: true,
      freeMode: true,
      // centeredSlides: true,
      loop: false,
      onTab: function (swiper) {
        var n = swiper_tab.clickedIndex;
      }
    });

    $.each(swiper_tab.slides, function (index, val) {
      var ele = $(this);
      ele.on("click", function () {
        setCurrentSlide(ele, index);
        swiper_tab_body.slideTo(index, 500, false);
        // mySwiper.initialSlide=index;
      });
    });

    this.loadingShow();
    this.mobileOrderConfig = await getMobileOrderConfig();
    switch(this.type){
      case 'pickup':
        this.mobileOrderProviders = await getMobileOrderTenants(this.$store.state.userId);
        break;
      case 'drivethru':
        this.mobileOrderProviders = await getDriveOrderTenants(this.$store.state.userId);
        break;
      case 'parkandpickup':
        this.mobileOrderProviders = await getParkAndPickupOrderTenants(this.$store.state.userId);
        break;
      case 'reservation':
        this.$router.push("/mobileorder");
        return;
    }
    this.mobileOrderProvidersFood = this.mobileOrderProviders.filter(t => t.data().shopCategoryType == "5");
    this.mobileOrderProvidersNonFood = this.mobileOrderProviders.filter(t => t.data().shopCategoryType != "5");
    this.mobileOrderProvidersAvailable = this.mobileOrderProviders.filter(item => {
      return this.isOrderEnabled(item.data(), this.type, this.$store.state.userId);
    })
    this.mobileOrderProvidersFoodAvailable = this.mobileOrderProvidersAvailable.filter(t => t.data().shopCategoryType == "5");
    this.mobileOrderProvidersNonFoodAvailable = this.mobileOrderProvidersAvailable.filter(t => t.data().shopCategoryType != "5");
    this.mobileOrderProvidersUnavailable = this.mobileOrderProviders.filter(item => {
      return !this.isOrderEnabled(item.data(), this.type, this.$store.state.userId);
    })
    this.mobileOrderProvidersFoodUnavailable = this.mobileOrderProvidersUnavailable.filter(t => t.data().shopCategoryType == "5");
    this.mobileOrderProvidersNonFoodUnavailable = this.mobileOrderProvidersUnavailable.filter(t => t.data().shopCategoryType != "5");
    this.mobileOrderProvidersCount = this.mobileOrderProviders.length;
    this.mobileOrderProvidersFoodCount = this.mobileOrderProvidersFood.length;
    this.mobileOrderProvidersNonFoodCount = this.mobileOrderProvidersNonFood.length;
    this.loadingHide();
    if (this.mobileOrderProvidersAvailable?.length == 0) {
      const res = await this.confirm("現在ご注文可能な店舗がありません。モバイルオーダートップに戻ります。", true);
      await this.$store.dispatch('clearCart');
      this.$router.push("/mobileorder");
      return;
    }
    const userId = this.$store.state.userId;
    const orders = await getMyOrders(userId)
    this.orders = orders;

    var swiper_tab_body = new Swiper('.js-swiper_tab_body', {
      direction: 'horizontal',
      loop: false,
      autoHeight: true,
      on: {
        slideChangeTransitionEnd: function () {
          var n = swiper_tab_body.activeIndex;
          setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(n), n);
          swiper_tab.slideTo(n, 500, false);
        },
      }
    });
    const delivType = Common.getUrlParam('type');
    if (delivType !== null){
      setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(delivType), delivType);
      swiper_tab_body.slideTo(delivType, 0, false);
    }
  },
  computed: {
    title() {
      switch (this.type){
        case 'pickup':
          return "モバイルオーダー";
        case 'drivethru':
          return "ドライブスルー";
        case 'parkandpickup':
          return this.mobileOrderConfig ? this.mobileOrderConfig.parkAndPickupAreaName+"受け取り" : "";
        case 'reservation':
          return '来店予約';
      }
      return "";
    }
  },
  methods: {
    async backToMobileorderTop() {
      const result = await this.confirm("受け取り方法を変更されますと、カート内の商品が全て削除されますが、よろしいですか？", false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (result) {
        await this.$store.dispatch('clearCart');
        this.$router.push('/mobileorder');
      }
    },
    isEnableTimebase(tenant) {
      const type = this.getOrderType();
      if ((type == 1 && tenant.data().enableTimebasePickup) || (type == 3 && tenant.data().enableTimebaseReservation)) {
        return false;
      } 
      return true;
    },
      getOrderType(){
      switch(this.type){
        case 'pickup':
          return 1;
        case 'delivery':
        case 'drivethru':
        case 'parkandpickup':
          return 2;
        case 'reservation':
          return 3;
        default:
          //nothing
      }
    },
    isPriceNoticeRequired(tenant){
      //「商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わります」
      return tenant && tenant.data().shopCategoryType == 5 
        && tenant.data()?.handlingFormatToGo?.enabled 
        && tenant.data()?.handlingFormatForHere?.enabled;
    }
  }
})
</script>